/* unplugin-vue-components disabled */import script from "./ScreenFull.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScreenFull.vue?vue&type=script&setup=true&lang=ts"

import "./ScreenFull.vue?vue&type=style&index=0&id=5f677368&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f677368"]])

export default __exports__